export default from './delete-post-modal';



// WEBPACK FOOTER //
// ./app/containers/delete-post-modal/index.js